import {
  GET_ALL_PARTNER_HOSTS_LOADING,
  GET_ALL_PARTNER_HOSTS_SUCCESS,
  GET_ALL_PARTNER_HOSTS_FAILED,
} from "../types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

type Action = {
  type: string;
  loading?: boolean;
  payload?: any;
  error?: any;
};

const getAllPartnerHostsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case GET_ALL_PARTNER_HOSTS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_ALL_PARTNER_HOSTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case GET_ALL_PARTNER_HOSTS_FAILED:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default getAllPartnerHostsReducer;
